/**
 * The user's current time: the device clock corrected by `offsetMs`, the difference between the
 * server's view of the user's time (real time plus any test-clock offset) and the device clock
 * when the session was fetched. Corrects device clock skew and follows the test clock.
 */
export function userNow(offsetMs: number, deviceNowMs: number = Date.now()): Date {
  return new Date(deviceNowMs + offsetMs)
}

/** Offset between the server's `now` and the device clock at the moment it was received. */
export function serverOffset(serverNowIso: string, deviceNowMs: number = Date.now()): number {
  return Date.parse(serverNowIso) - deviceNowMs
}
